import React, { useRef } from "react";
import { useGoogleAddressAutocomplete } from "@/lib/googleMaps";

/**
 * Drop-in replacement for a plain address `<input>` that layers Google Places
 * autocomplete on top. If the SDK fails to load (no key / blocked / offline),
 * it degrades gracefully to a normal input with browser autocomplete.
 *
 * Controlled component — the parent still owns the `value` / `onChange` state;
 * on suggestion-select we fire both so React re-renders with the picked value.
 */
export default function GoogleAddressInput({
  value,
  onChange,
  placeholder = "Start typing your address…",
  className = "",
  testId,
  required,
  autoComplete = "street-address",
  ...rest
}) {
  const inputRef = useRef(null);
  useGoogleAddressAutocomplete({
    inputRef,
    onSelect: (addr) => onChange(addr),
  });

  return (
    <input
      ref={inputRef}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={className}
      data-testid={testId}
      required={required}
      autoComplete={autoComplete}
      {...rest}
    />
  );
}
